/**
 * O relógio e o frescor de uma tela de painel.
 *
 * É O ELEMENTO MAIS IMPORTANTE DE QUALQUER TELA DE PAREDE, e por isso mora
 * num componente só: um painel congelado mostrando tudo verde é pior que um
 * painel apagado — o apagado ninguém acredita. Se a regra do "há quanto
 * tempo é velho" existisse em duas telas, uma delas ia envelhecer errado.
 */

import { useEffect, useState } from "react";

/** O dobro do intervalo de atualização dos dados (10 s), com folga larga.
 *  Acima disso a tela para de afirmar que está viva. */
const LIMITE_DE_FRESCOR_S = 180;

/** Quantos segundos desde a última vez que os dados CHEGARAM. */
export function useSegundosDesde(marca: number) {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setAgora(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  return Math.max(0, Math.round((agora - marca) / 1000));
}

/**
 * `marca` é o `dataUpdatedAt` de uma query — quando o dado CHEGOU, não
 * quando foi pedido. É a única marca que distingue "a tela está viva" de "a
 * tela continua desenhando o que buscou ontem".
 */
export function RelogioDoPainel({ marca }: { marca: number }) {
  const frescor = useSegundosDesde(marca || Date.now());
  const velho = frescor > LIMITE_DE_FRESCOR_S;

  const [relogio, setRelogio] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setRelogio(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="text-right">
      <div className="text-4xl font-semibold tabular-nums text-slate-900 dark:text-slate-100">
        {relogio.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
      </div>
      <div
        className={
          "text-sm " +
          (velho
            ? "font-semibold text-rose-600 dark:text-rose-400"
            : "text-slate-500 dark:text-slate-400")
        }
      >
        {velho
          ? `sem atualizar há ${Math.floor(frescor / 60)} min`
          : `atualizado há ${frescor}s`}
      </div>
    </div>
  );
}
